import { SubscriptionProductNames } from '@/interfaces/subscription'
import { User } from 'containers/user/types/user'

export interface DissmisedRecommendationsStore {
  dismissedRecommendations: string[]
  dismissRecommendation: (recommendationId: string) => void
}
export interface ProfileRecommendation extends User {
  // Required Properties
  firstName: string
  recommendationType: ProfileRecommendationType

  // Optional Properties
  about?: string
  avatar?: string
  creatorType?: string[]
  email?: string
  engagements?: number
  id?: string
  interests?: string[]
  lastName?: string
  location?: string
  mutualContacts?: number
  organization?: string
  socialMediaUrl?: string
  username?: string
  title?: string
  totalAudience?: number
  verified?: boolean
  company?: string
  subscriptions?: Record<SubscriptionProductNames, boolean>
  subscribed?: boolean
  contentType?: string[]
}

export enum ProfileRecommendationType {
  HOT_PROFILE = 'HotProfile',
  COLD_PROFILE = 'ColdProfile',
  GPP_PROFILE = 'GPProfile',
  NETWORKER = 'TopNetworker',
}

export interface NetworkersQueryParams {
  count: number
  timeFrame: number
  filterFreebird: boolean
}
